import { render, staticRenderFns } from "./NsbTerdaftar.vue?vue&type=template&id=331ba828&scoped=true&"
import script from "./NsbTerdaftar.vue?vue&type=script&lang=js&"
export * from "./NsbTerdaftar.vue?vue&type=script&lang=js&"
import style0 from "./NsbTerdaftar.vue?vue&type=style&index=0&id=331ba828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ba828",
  null
  
)

export default component.exports